import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { SubmitHandler } from 'react-hook-form';
import { UpdateDepartmentDto } from '@area-restrita/api-client/model/updateDepartmentDto';
import {
  useGetCompanyDepartmentDetailSuspense,
  useUpdateCompanyDepartment,
} from '@area-restrita/api-client/endpoints/departments/departments.gen';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import DepartmentForm from '../../components/DepartmentForm';

interface IProps {
  id: number;
}

const CompanyDepartmentDetails: React.FC<IProps> = ({ id }) => {
  const { data: department } = useGetCompanyDepartmentDetailSuspense(id);

  const updateDepartmentMutation = useUpdateCompanyDepartment();

  const handleSubmit = useCallback<SubmitHandler<UpdateDepartmentDto>>(
    (data) =>
      updateDepartmentMutation.mutateAsync(
        { id, data },
        {
          onSuccess: () => {
            toast.success('Departamento atualizado com sucesso!');
          },
          onError: () => {
            toast.error('Erro ao atualizar departamento');
          },
        },
      ),
    [id, updateDepartmentMutation],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Detalhes do Departamento - {department.name}</CardTitle>
        <CardDescription>
          Aqui você pode visualizar e gerenciar os detalhes do departamento
          selecionado.
        </CardDescription>
      </CardHeader>
      <DepartmentForm
        defaultValues={{
          name: department.name,
          description: department.description,
          rules: department.rules,
        }}
        onSubmit={handleSubmit}
      />
    </Card>
  );
};

export default CompanyDepartmentDetails;
